// type
import type { Components, Theme } from "@mui/material";

export const MuiDivider: Components<Theme>["MuiDivider"] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      borderColor: theme.palette.divider,
      ".MuiDivider-wrapper p": {
        fontSize: theme.typography.body2.fontSize,
      },
      "&::before": { width: "3%" },
    }),
  },
};
